import { type GridColDef } from "@mui/x-data-grid";

import { PublicProtectionProfile } from "api/public/protectionProfiles/protectionProfiles.types";
import LinkButtonCell from "components/MUI/DataGrid/Cells/LinkButton.cell";
import {
  dataGridDateGetter,
  dataGridDateOnlyGetter,
} from "components/MUI/DataGrid/DataGrid.utils";

import StatusCell from "./Cells/Status.cell";

export const ppColumns: GridColDef<PublicProtectionProfile>[] = [
  {
    headerName: "Short Name",
    field: "pp_short_name",
    flex: 1,
    minWidth: 120,
  },
  {
    headerName: "Profile Name",
    field: "pp_name",
    flex: 3,
    minWidth: 300,
  },
  {
    headerName: "Technology Type",
    field: "tech_type",
    flex: 1,
    minWidth: 150,
  },
  {
    headerName: "Status",
    field: "status",
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }) => <StatusCell row={row} />,
  },
  {
    headerName: "Approved",
    field: "pp_date",
    flex: 1,
    minWidth: 110,
    type: "date",
    valueGetter: dataGridDateOnlyGetter,
  },
  {
    headerName: "CC Version",
    field: "cc_version",
    flex: 1,
    minWidth: 100,
  },
  {
    headerName: "Sponsor",
    field: "pp_sponsor_id",
    flex: 1,
    minWidth: 100,
  },
  {
    headerName: "Sunset Date",
    field: "sunset_date",
    flex: 1,
    minWidth: 110,
    type: "date",
    valueGetter: dataGridDateOnlyGetter,
  },
  {
    headerName: "Transition Date",
    field: "pp_transition",
    flex: 1,
    minWidth: 120,
    type: "date",
    valueGetter: dataGridDateOnlyGetter,
  },
  {
    headerName: "",
    field: "_actions",
    sortable: false,
    flex: 0,
    minWidth: 130,
    renderCell: ({ row }) => (
      <LinkButtonCell
        to={`/protectionprofiles/${row.pp_id}`}
        label="Full Details"
        sx={{ textTransform: "none" }}
      />
    ),
    disableExport: true,
  },
];
